import { Outlet } from "react-router-dom";
import { SidebarContent } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";

export default function Layout() {
  return (
    <div className="min-h-screen bg-background">
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 z-40">
        <SidebarContent />
      </aside>
      <div className="lg:pl-64">
        <Topbar />
        <main className="min-h-[calc(100vh-4rem)]">
          <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 space-y-6 animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
